import { z } from "zod";

export const selectWarehouseLocationsSchema = z.object({
	warehouseLocationIds: z
		.array(z.uuid())
		.min(1, "At least one warehouse location must be selected"),
});

export type SelectWarehouseLocationsSchema = z.infer<typeof selectWarehouseLocationsSchema>;
